import { createTheme } from "@mui/material/styles";

// Lifetree brand: a deep forest green with a warm neutral background.
const theme = createTheme({
  palette: {
    primary: { main: "#2e6b3f", light: "#4f8f5f", dark: "#1f4d2c" },
    secondary: { main: "#8a5a2b" },
    background: { default: "#f5f6f4", paper: "#ffffff" },
    text: { primary: "#1d2420", secondary: "#5d6861" },
    divider: "#e3e6e2",
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 600 },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiAppBar: {
      defaultProps: { elevation: 0, color: "inherit" },
      styleOverrides: {
        root: { borderBottom: "1px solid #e3e6e2", background: "#ffffff" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiPaper: {
      styleOverrides: { outlined: { borderColor: "#e3e6e2" } },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": { backgroundColor: "rgba(46, 107, 63, 0.10)" },
          "&.Mui-selected:hover": {
            backgroundColor: "rgba(46, 107, 63, 0.16)",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: { root: { backgroundColor: "#ffffff" } },
    },
  },
});

export default theme;
